import { MessageCircle } from "lucide-react";
import { cityConfig } from "@/config/cityConfig";

export default function WhatsAppWidget() {
  return (
    <a
      href={`https://wa.me/${cityConfig.whatsapp}?text=Hallo%2C%20ich%20interessiere%20mich%20f%C3%BCr%20eine%20Immobilienberatung%20im%20Kreis%20Mettmann.`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] text-white p-4 rounded-full shadow-lg hover:bg-[#20BD5A] transition-all duration-300 hover:scale-110 group"
      aria-label="WhatsApp Chat starten"
      data-testid="whatsapp-widget"
    >
      <MessageCircle size={24} className="fill-white" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[#0d0d0d] text-white text-xs font-bold px-3 py-2 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none border border-white/10">
        WhatsApp Chat
      </span>
    </a>
  );
}
